import React from 'react';
import { useTitle } from 'react-use';

import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { RoutedStepProps } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.types';

import { IrshStepValues } from '../IrshPages.types';

import { ClaimGroupDeposit } from './ClaimGroupDeposit/ClaimGroupDeposit';
import { useGetGroupedCarriers } from './hooks/useGetGroupedCarriers';
import messages from './messages';

const ClaimGroupDepositPage: React.FC<RoutedStepProps<IrshStepValues>> = ({
  onPreviousStep,
  onNextStep,
}) => {
  const { groupedCarriers } = useGetGroupedCarriers();

  useTitle(buildPageTitle([messages.claimGroupDepositTitlePage]));

  if (!groupedCarriers) {
    return <BaseLoader />;
  }

  return (
    <ClaimGroupDeposit
      onNextStep={onNextStep}
      onPreviousStep={onPreviousStep}
    />
  );
};

export default ClaimGroupDepositPage;
